module.exports = {"410725002":"阳和街道","410725003":"原兴街道","410725103":"齐街镇","410725104":"太平镇","410725105":"福宁集镇","410725107":"官厂镇","410725108":"大宾镇","410725200":"葛埠口乡","410725206":"蒋庄乡","410725211":"陡门乡","410725215":"路寨乡","410725216":"阳阿乡","410725218":"靳堂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410725.json
// module id = 1709
// module chunks = 0